import { appIdReducer } from "./appIdReducer";
import authUserReducer from "./authUserReducer";
import {combineReducers} from 'redux';
import { userDetailsReducer } from "./userDetails";
import { idxReducer } from "./idxReducer";
import { homeReducer } from "./homeReducer";

const reducers = combineReducers({
    allFiles: appIdReducer,
    authState: authUserReducer,
    userDetails: userDetailsReducer,
    idxState: idxReducer,
    homeState: homeReducer
})

export default reducers;